import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "./lib/auth";
import { Toaster } from "./components/ui/sonner";
import Navbar from "./components/Navbar";
import HomePage from "./pages/HomePage";
import CategoryPage from "./pages/CategoryPage";
import PlaceDetailPage from "./pages/PlaceDetailPage";
import GlobalMapPage from "./pages/GlobalMapPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminPage from "./pages/AdminPage";
import PricingPage from "./pages/PricingPage";
import OwnerSignupPage from "./pages/OwnerSignupPage";
import OwnerDashboardPage from "./pages/OwnerDashboardPage";
import InstallBanner from "./components/InstallBanner";
import BottomNav from "./components/BottomNav";
import RideLandingPage from "./pages/ride/RideLandingPage";
import RideRequestPage from "./pages/ride/RideRequestPage";
import RideTrackPage from "./pages/ride/RideTrackPage";
import DriverSignupPage from "./pages/ride/DriverSignupPage";
import DriverDashboardPage from "./pages/ride/DriverDashboardPage";
import AdminRidePage from "./pages/ride/AdminRidePage";
import GroceryHomePage from "./pages/grocery/GroceryHomePage";
import ShopPage from "./pages/grocery/ShopPage";
import CartCheckoutPage from "./pages/grocery/CartCheckoutPage";
import OrderTrackPage from "./pages/grocery/OrderTrackPage";
import AdminGroceryPage from "./pages/grocery/AdminGroceryPage";
import RestaurantOrderPage from "./pages/grocery/RestaurantOrderPage";

function App() {
  return (
    <div className="App min-h-screen bg-background text-foreground">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/carte" element={<GlobalMapPage />} />
            <Route path="/place/:id" element={<PlaceDetailPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/tarifs" element={<PricingPage />} />
            <Route path="/devenir-annonceur" element={<OwnerSignupPage />} />
            <Route path="/annonceur" element={<OwnerDashboardPage />} />
            <Route path="/ride" element={<RideLandingPage />} />
            <Route path="/ride/request" element={<RideRequestPage />} />
            <Route path="/ride/track/:id" element={<RideTrackPage />} />
            <Route path="/ride/driver/signup" element={<DriverSignupPage />} />
            <Route path="/ride/driver" element={<DriverDashboardPage />} />
            <Route path="/ride/admin" element={<AdminRidePage />} />
            <Route path="/courses" element={<GroceryHomePage />} />
            <Route path="/courses/shop/:id" element={<ShopPage />} />
            <Route path="/courses/panier" element={<CartCheckoutPage />} />
            <Route path="/courses/commande/:id" element={<OrderTrackPage />} />
            <Route path="/courses/admin" element={<AdminGroceryPage />} />
            <Route path="/restaurants/order" element={<RestaurantOrderPage />} />
            <Route path="/:category" element={<CategoryPage />} />
          </Routes>
          <Toaster position="top-right" richColors />
          <InstallBanner />
          <BottomNav />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
